<div class="input-wrapper">
  <mat-icon [svgIcon]="svgIconsEnum.Search"></mat-icon>
  <input type="text"
         (keyup)="keyup.emit()"
         (blur)="onBlur.emit()"
         (focus)="onFocus.emit()"
         [placeholder]="placeholder"
         [formControl]="control"/>
</div>
